import { Injectable, effect, inject } from '@angular/core';
import { App } from '@capacitor/app';
import { AuthSessionService } from '../../../shell/auth/auth-session.service';
import { WoConnectivityService } from './wo-connectivity.service';
import { WoOfflineOutboxService } from './wo-offline-outbox.service';
import { WoOfflineSyncService } from './wo-offline-sync.service';

/**
 * Boots network listeners and flushes the WO outbox when online + authenticated.
 */
@Injectable({ providedIn: 'root' })
export class WoOfflineBootstrapService {
  private readonly connectivity = inject(WoConnectivityService);
  private readonly sync = inject(WoOfflineSyncService);
  private readonly outbox = inject(WoOfflineOutboxService);
  private readonly auth = inject(AuthSessionService);

  private started = false;

  constructor() {
    effect(() => {
      const online = this.connectivity.online();
      const session = this.auth.currentUser();
      if (online && session) {
        void this.sync.flushAll();
      }
    });
  }

  async start(): Promise<void> {
    if (this.started) {
      return;
    }
    this.started = true;
    await this.connectivity.start();
    await this.outbox.hydrate();
    try {
      await App.addListener('resume', () => {
        void this.sync.flushAll();
      });
    } catch {
      /* web / missing plugin */
    }
    if (this.connectivity.online() && this.auth.snapshot) {
      void this.sync.flushAll();
    }
  }
}
